import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { fg } from '@confluence/feature-gating';
import { preloadAIFCOnboardingStateForTopNav } from '@confluence/onboarding-helpers/entry-points/preloadAIFCOnboardingStateForTopNav.ts';

import TopNavigationQuery, {
	type TopNavigationQuery$data,
	type TopNavigationQuery$variables,
} from './__generated__/TopNavigationQuery.graphql.ts';
import { preloadUnseenNotificationCount } from './preloadNotificationCount.ts';

export async function preloadTopNavigation() {
	const { userId } = getPreloaderFnContext();

	const topNavigationPromises: Promise<any>[] = [
		query<TopNavigationQuery$data, TopNavigationQuery$variables>({
			query: TopNavigationQuery,
			variables: {
				includeNav4AdminOptIn: fg('confluence_nav4_ga_phase_1'),
			},
		}),
	];

	if (fg('aifc_create_enabled')) {
		topNavigationPromises.push(preloadAIFCOnboardingStateForTopNav());
	}

	if (userId && fg('confluence_frontend_preload_notifications')) {
		//skip for anon
		topNavigationPromises.push(preloadUnseenNotificationCount());
	}

	return waitForAllReturnWhenError(topNavigationPromises);
}
